import React, { Component } from 'react';
import { array } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import EsmsCard from '../../components/EsmsCard';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './BasAgentsCard.module.css';

class BasAgentsCard extends Component {
    static propTypes = {
        basAgents: array
    }

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/iothub/basagents' + history.location.search);
    }

    render() {
        let { currentScopes, basAgents } = this.props;

        return (
            <EsmsCard
                title="BAS Agents"
                imagePath="/assets/images/basAgentIconColor.svg"
            >
                <div className={classes.innerContainer}>
                    <div className={classes.basAgentsInfo}>
                        <div>
                            <span className={classes.title}>Total Agents</span>
                            <span className={classes.data}>{basAgents.length || 0}</span>
                        </div>
                        <div>
                            <span className={classes.title}>Connected Agents</span>
                            <span className={classes.data}>
                                {basAgents.filter(agent => agent.connected).length || 0}
                            </span>
                        </div>
                    </div>
                    {
                        isAllowed(currentScopes, Permissions('iothubRead')) &&
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePageRoute}
                        >
                            Manage BAS Agents
                        </Button>
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    return {
        basAgents:     Object.values(basAgent.basAgents),
        currentScopes: state.core.currentScopes
    };
};

export default withRouter(connect(mapStateToProps)(BasAgentsCard));
